import Badge from 'antd-mobile/lib/badge';
export default Badge;



// WEBPACK FOOTER //
// ./components/badge/index.tsx